import { render, staticRenderFns } from "./RankingMammoth.vue?vue&type=template&id=04f22c80&scoped=true&"
import script from "./RankingMammoth.vue?vue&type=script&lang=js&"
export * from "./RankingMammoth.vue?vue&type=script&lang=js&"
import style0 from "./RankingMammoth.vue?vue&type=style&index=0&id=04f22c80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f22c80",
  null
  
)

export default component.exports